
// @ts-ignore
    import __i18nConfig from '@next-translate-root/i18n'
// @ts-ignore
    import __loadNamespaces from 'next-translate/loadNamespaces'
// @ts-ignore
    
import React from "react";
import useTranslation from "next-translate/useTranslation";

import { Converter } from "@/containers/Converter";
import { Head } from "@/components/Head";

import { MagicianSection } from "@/sections/MagicianSection";
import { TrustedBySection } from "@/sections/TrustedBySection";
import { SelectFormatSection } from "@/sections/SelectFormatSection";
import { ConvertEverythingSection } from "@/sections/ConvertEverythingSection";
import { TryBeforeYouBuySection } from "@/sections/TryBeforeYouBuySection";
import { ConversionSection } from "@/sections/ConversionSection";
import { VideoSection } from "@/sections/VideoSection";

const FigmaToXd = () => {
  const { t } = useTranslation();

  return (
    <>
      <Head
        pageNamespace="page/FigmaToXD"
        ogImage="/images/figma2xd-og-image.jpg"
      />

      <MagicianSection
        title={t("page/FigmaToXD:title")}
        subtitle={t("page/FigmaToXD:subtitle")}
        magicianLogoFile="xd"
        cta={{
          title: t("section/magicians:seeHowItWorks"),
          scrollToId: "ConvertEverythingSection",
        }}
      >
        <Converter />
      </MagicianSection>

      <TrustedBySection />

      <ConvertEverythingSection
        images={[
          {
            src: "/svgs/convert-everything/symbols-components-figma-to-xd.svg",
            alt: "symbols/components",
          },
          {
            src:
              "/svgs/convert-everything/prototyping-transitions-figma-to-xd.svg",
            alt: "prototyping/transitions",
          },
          {
            src: "/svgs/convert-everything/text-and-colors-xd.svg",
            alt: "text-and-colors",
          },
        ]}
      />

      <TryBeforeYouBuySection
        title={t("page/FigmaToXD:section/tryBeforeBuy.title")}
        elements={[
          {
            id: "ELEMENT#1",
            iconType: "BOX",
            text: t(
              "page/FigmaToXD:section/tryBeforeBuy.elements.firstElementText",
            ),
          },
          {
            id: "ELEMENT#2",
            iconType: "SHIELD",
            text: t(
              "page/FigmaToXD:section/tryBeforeBuy.elements.secondElementText",
            ),
          },
          {
            id: "ELEMENT#3",
            iconType: "LOCK",
            text: t(
              "page/FigmaToXD:section/tryBeforeBuy.elements.thirdElementText",
            ),
          },
        ]}
        cta={{
          title: t("page/FigmaToXD:section/tryBeforeBuy.actionLabel"),
        }}
      />
      <VideoSection
        title={t("page/FigmaToXD:section/videoSection.title")}
        subtitle={t("page/FigmaToXD:section/videoSection.subtitle")}
        media={{
          type: "PHOTO",
          title: "Upload demo",
          src: "/images/import-figma-in-xd.jpg",
        }}
      />

      <ConversionSection
        title={t("section/conversion:title")}
        iconBadges={[
          {
            iconType: "SHEETS",
            text: t("section/conversion:badges.supportsAll"),
          },
          {
            iconType: "TV",
            text: t("section/conversion:badges.artboardStyleSupport"),
          },
        ]}
        elements={{
          from: {
            iconType: "FIGMA",
            image: "/images/figma-preview.jpg",
            title: "Figma Demo Preview",
          },
          to: {
            iconType: "ADOBEXD",
            image: "/images/xd-preview.jpg",
            title: "Xd Demo Preview",
          },
        }}
      />
      <SelectFormatSection title={t("section/selectFormat:title")} />
    </>
  );
};

// Temporal workaround for https://github.com/vercel/next.js/discussions/18396
 async function _getStaticProps() {
  return {
    props: {},
  };
}

export default FigmaToXd;


// @ts-ignore
    export async function getStaticProps(ctx) {
// @ts-ignore
        let res = _getStaticProps(ctx)
// @ts-ignore
        if(typeof res.then === 'function') res = await res
// @ts-ignore
        return {
// @ts-ignore
          
// @ts-ignore
          ...res,
// @ts-ignore
          props: {
// @ts-ignore
            ...(res.props || {}),
// @ts-ignore
            ...(await __loadNamespaces({
// @ts-ignore
              ...ctx,
// @ts-ignore
              pathname: '/converter/figma-to-xd',
// @ts-ignore
              loaderName: 'getStaticProps',
// @ts-ignore
              ...__i18nConfig,
// @ts-ignore
              
// @ts-ignore
            }))
// @ts-ignore
          }
// @ts-ignore
        }
// @ts-ignore
    }
// @ts-ignore
  